// extracted by mini-css-extract-plugin
export default {"wrapper":"UnsuccessfulDepositCode_wrapper--sxg","contentWrapper":"UnsuccessfulDepositCode_contentWrapper--YP4","supportSection":"UnsuccessfulDepositCode_supportSection--nPq"};